import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { useLocation, useNavigate } from 'react-router'
import styled from 'styled-components'
import MenuItem from '~/components/menuItem'

const Container = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  gap: 10px;
  margin: 0.25rem 0;
`

type NavItemProps = {
  to?: string
  onClick: () => void
  label: string
  icon: IconDefinition
}

const DrawerNavItem = ({ to, onClick, label, icon }: NavItemProps) => {
  const location = useLocation()
  const navigate = useNavigate()
  const isActive = !!to && location.pathname === to

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault()
    onClick()
    if (!to) return
    navigate(to || '')
  }

  return (
    <Container>
      <MenuItem onClick={handleClick} $isActive={isActive} label={label} icon={icon} size='xs' />
    </Container>
  )
}

export default DrawerNavItem
